export function formatAddress(location) {
  if (!location) {
    return '';
  }

  const {
    subThoroughfare,
    thoroughfare,
    locality,
    administrativeArea,
    postalCode,
  } = location;

  const streetLine = [subThoroughfare, thoroughfare]
    .map(part => (typeof part === 'string' ? part.trim() : part))
    .filter(Boolean)
    .join(' ')
    .trim();

  const cityLine = typeof locality === 'string' ? locality.trim() : locality;
  const statePostal = [administrativeArea, postalCode]
    .map(part => (typeof part === 'string' ? part.trim() : part))
    .filter(Boolean)
    .join(' ')
    .trim();

  return [streetLine, cityLine, statePostal]
    .filter(part => part && part.length > 0)
    .join(', ');
}
